export default "__VITE_ASSET__C3EjX3Lq__"